import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser'
import SomeParticle from '../common/SomeParticle';
import SpritePool from '../common/SpritePool';
import FontKeys from '../FontKeys';
import SoundAssetKeys from '../SoundAssetKeys';

export default class ResultsDisplay extends Phaser.GameObjects.Container {
  /**
   * 
   * @param {Phaser.Scene} scene 
   */
  constructor(scene) {
    super(scene);

    this.bg = ABCyaPhaser.Images.addImage(0, 0, "results_bg", this);

    this.starPool = new SpritePool(SomeParticle, 50, this.scene);
    this.starParticles = [];

    let starLocs = [{ x: 30, y: 40 }, { x: 80, y: 20 }, { x: 130, y: 40 }];
    this.stars = [];
    let item;
    for (let i = 0; i < starLocs.length; i++) {
      item = ABCyaPhaser.Images.addImage(0, 0, "star_off", this);
      this.stars.push(item);
      this.add(item);
      item.x = starLocs[i].x;
      item.y = starLocs[i].y;
    }

    this.lblScore = ABCyaPhaser.Text.addText(0, 0, 56, 0x727272, FontKeys._bpreplaybold, "95%", this, true).setPadding(20);
    this.lblScore.x = this.bg.width / 2;
    this.lblScore.y = this.bg.height / 2 + 10;
    ABCyaPhaser.Text.setFontStyle(this.lblScore, true);

    // the original code changed the registration point of the container, which isn't possible in Phaser, so instead we just adjust all the children positions
    let bounds = this.getBounds();
    this.iterate(c => {
      c.x -= bounds.width / 2;
      c.y -= bounds.height / 2;
    });
  }

  showResults(value) {
    this.resetStars();
    this.scale = 0;
    this.lblScore.text = value + "%";
    this.currentScore = value;
    if (value >= 100) {
      this.maxDisplayStar = 3;
    } else if (value >= 90) {
      this.maxDisplayStar = 2;
    } else if (value >= 80) {
      this.maxDisplayStar = 1;
    } else {
      this.maxDisplayStar = 0;
    }
    this.currentDisplayStar = 0;
    this.lblScore.scale = 0;
    this.alpha = 0;
    ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._pop_06a, this.scene);
    ABCyaPhaser.Tweens.addTween(this, 1400, { scale: 1 }, Phaser.Math.Easing.Elastic.Out, () => this.startStarShow());
    ABCyaPhaser.Tweens.addTween(this, 120, { alpha: 1 }, Phaser.Math.Easing.Linear);
    this.scene.time.delayedCall(400, this.showScoreLabel, null, this);
  }

  showScoreLabel() {
    ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._pop_06a, this.scene);
    ABCyaPhaser.Tweens.addTween(this.lblScore, 400, { scale: 1 }, Phaser.Math.Easing.Elastic.Out);
  }

  startStarShow() {
    if (this.maxDisplayStar > 0) {
      this.showCurrentStar(null);
    }
    else {
      //ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._you_made_too_many_mistakes, this.scene);
      this.finishedDisplay();
    }
  }

  showCurrentStar() {
    this.stars[this.currentDisplayStar].setFrame("star_on");
    ABCyaPhaser.Audio.playOneShot((this.currentDisplayStar + 1) + "_star", this.scene);
    this.currentDisplayStar++;
    if (this.currentDisplayStar < this.maxDisplayStar) {
      this.scene.time.delayedCall(300, this.showCurrentStar, null, this);
    }
    else {
      this.finishedDisplay();
    }
  }

  finishedDisplay() {
    if (this.maxDisplayStar === 3) {
      this.scene.time.delayedCall(450, this.showStarBurst, null, this);
    }
    else {
      this.emit("RESULTS_DISPLAYED");
    }
  }

  showStarBurst() {
    ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._final_burst, this.scene);
    this.createStarParticles(this.lblScore.x, this.lblScore.y);
    this.emit("RESULTS_DISPLAYED");
  }

  createStarParticles(x, y) {
    let count = 50, item = null;
    for (let i = 0; i < count; i++) {
      item = this.starPool.getSprite();
      item.reset(x, y, "star_on");
      this.add(item);
      this.starParticles.push(item);
    }
  }

  resetStarParticle(i) {
    this.remove(this.starParticles[i]);
    this.starPool.returnSprite(this.starParticles[i]);
    this.starParticles.splice(i, 1);
  }

  resetStars() {
    let count = this.stars.length;
    for (let i = 0; i < count; i++) {
      this.stars[i].setFrame("star_off");
    }
  }

  hide() {
    ABCyaPhaser.Tweens.addTween(this, 200, { scale: 0, alpha: 0 }, Phaser.Math.Easing.Linear);
    this.destroyAllStars();
  }

  destroyAllStars() {
    let len = this.starParticles.length - 1, item = null;
    for (let i = len; i >= 0; i--) {
      item = this.starParticles[i];
      this.resetStarParticle(i);
    }
  }

  tick(e) {
    let len = this.starParticles.length - 1, item = null;
    for (let i = len; i >= 0; i--) {
      item = this.starParticles[i];
      if (item.y > this.scene.scale.height + 100) {
        this.resetStarParticle(i);
      }
      else {
        item.tick(e);
      }
    }
  }
}